import React from "@platform/react";
import { Component } from "@platform/react-storybook/Component";

import { Text } from "@front/components/Element/Text";
import { Button } from "@front/components/Element/Button";
import { SectionCardVertical } from "@front/components/Section/Card/Vertical";
import { DATA_VERTIVCALCARDS_CHALLENGE } from "@front/components/Page/CrackChallenge/data";

import Rules from "./_rules.module.scss";
import type { PropTypesPreview } from "./types";
import { DEF_PREVIEW, NAME_PREVIEW, TYPE_PREVIEW } from "./types";

export function SectionPreview(props: PropTypesPreview) {
    const { onClick, ...rest } = props;
    return (
        <Component {...rest} name={NAME_PREVIEW} tag="div" type={TYPE_PREVIEW}>
            <Text className={Rules.title} preset="torreon" uuid="title-challenges" />
            <SectionCardVertical {...DATA_VERTIVCALCARDS_CHALLENGE} hasTitle={false} />
            <Text raw className={Rules.information} preset="puebla" uuid="challenges-mixin-1" />
            <Button
                className={Rules.button}
                preset="nigeria"
                text="button-accept"
                onClick={onClick}
            />
        </Component>
    );
}
SectionPreview.defaultProps = DEF_PREVIEW;
